import React, { useContext, useState } from 'react';
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBNavbarToggler,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon,
} from 'mdbreact';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import { UserContext } from './UserContext';
import logo from '../nss_logo.png';

export default function NavbarPage() {
  const [isOpen, setIsOpen] = useState(false);
  const userContext = useContext(UserContext);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const renderDropDown = () => {
    if (userContext.name === '') {
      return (
        <></>
        // <MDBDropdownItem>
        //   <MDBNavLink className="black-text" to="/">
        //     Login
        //     {' '}
        //   </MDBNavLink>
        //   {' '}
        // </MDBDropdownItem>
      );
    }

    // Need to change this, possibly skip the google logout button if that's possible
    return (
      <>
        <MDBDropdownItem>
          <MDBNavLink className="black-text" to="/profile">
            {' '}
            Profile
            {' '}
          </MDBNavLink>
          {' '}
        </MDBDropdownItem>
        {' '}
        <MDBDropdownItem>
          <MDBNavLink
            className="black-text"
            to="/"
            onClick={userContext.logout}
          >
            {' '}
            Logout
            {' '}
          </MDBNavLink>
          {' '}
        </MDBDropdownItem>
        {' '}
      </>
    );
  };

  return (
    <MDBNavbar color="elegant-color-dark" dark expand="md">
      <img src={logo} alt="Nss Logo" style={{ height: '30px' }} />
      {' '}
      <MDBNavbarBrand>
        <strong className="white-text">
          &nbsp;&nbsp; NSS IITH Hours Portal
          {' '}
        </strong>
        {' '}
      </MDBNavbarBrand>
      {' '}
      <MDBNavbarToggler onClick={toggleCollapse} />
      {' '}
      <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
        <MDBNavbarNav right>
          <MDBNavItem>
            <a href="http://nss.iith.ac.in" className="nav-link">
              Home
              {' '}
            </a>
            {' '}
          </MDBNavItem>
          {' '}
          <MDBNavItem>
            <MDBNavLink to="/EventsPage"> Events </MDBNavLink>
            {' '}
          </MDBNavItem>
          {' '}
          <MDBNavItem>
            <MDBDropdown>
              <MDBDropdownToggle nav caret>
                <MDBIcon icon="user" />
                {' '}
                {`\t${userContext.name}`}
                {' '}
              </MDBDropdownToggle>
              {' '}
              <MDBDropdownMenu right className="dropdown-default">
                {' '}
                {renderDropDown()}
                {' '}
              </MDBDropdownMenu>
              {' '}
            </MDBDropdown>
            {' '}
          </MDBNavItem>
          {' '}
        </MDBNavbarNav>
        {' '}
      </MDBCollapse>
      {' '}
    </MDBNavbar>
  );
}
